'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { MFADeviceType } from '@dynamic-labs/sdk-api-core';
import { MfaInvalidOtpError } from '@dynamic-labs/utils';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../../utils/constants/colors.js';
import '../../../utils/constants/values.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '../../../shared/consts/index.js';
import { sdkApi } from '../api.js';

const getUserMfaDevices = (_a) => __awaiter(void 0, [_a], void 0, function* ({ environmentId, }) {
    try {
        const { devices } = yield sdkApi().getUserMfaDevices({
            environmentId,
        });
        return devices;
    }
    catch (e) {
        const data = yield e.json();
        logger.error(data.error);
        return [];
    }
});
const addMfaDevice = (_b) => __awaiter(void 0, [_b], void 0, function* ({ environmentId, type, }) {
    try {
        if (type === MFADeviceType.Totp) {
            const response = yield sdkApi().registerTotpMfaDevice({
                environmentId,
            });
            return response;
        }
        throw new Error('Unsupported MFA device type');
    }
    catch (e) {
        const message = e instanceof Error ? e.message : (yield e.json()).error;
        logger.error(message);
        throw new Error(message);
    }
});
const updateUserMfaDevice = (_c) => __awaiter(void 0, [_c], void 0, function* ({ environmentId, mfaDeviceId, }) {
    try {
        yield sdkApi().updateUserMfaDevice({
            environmentId,
            mfaDeviceId,
        });
    }
    catch (e) {
        const data = yield e.json();
        logger.error(data.error);
    }
});
const deleteMfaDevice = (_d) => __awaiter(void 0, [_d], void 0, function* ({ environmentId, mfaDeviceId, }) {
    try {
        yield sdkApi().deleteMfaDevice({
            environmentId,
            mfaDeviceId,
        });
    }
    catch (e) {
        const data = yield e.json();
        logger.error(data.error);
    }
});
// used when verifying a device added after the user is already logged in
// no jwt update needed
const verifyMfaDevice = (_e) => __awaiter(void 0, [_e], void 0, function* ({ environmentId, type, code, }) {
    try {
        if (type === MFADeviceType.Totp) {
            const request = {
                code,
                type,
            };
            const device = yield sdkApi().registerTotpMfaDeviceVerify({
                environmentId,
                mFARegisterTotpDevicePostRequest: request,
            });
            return device;
        }
        throw new Error('Unsupported MFA device type');
    }
    catch (e) {
        const message = e instanceof Error ? e.message : (yield e.json()).error;
        logger.error(message);
        return undefined;
    }
});
// used when verifying a device when user is logging in
// jwt update needed
const authMfaDevice = (_f) => __awaiter(void 0, [_f], void 0, function* ({ environmentId, type, code, createMfaToken, }) {
    try {
        if (type === MFADeviceType.Totp) {
            const request = {
                code,
                createMfaToken,
            };
            const response = yield sdkApi().authMfaTotpDevice({
                environmentId,
                mFAAuthTotpDevicePostRequest: request,
            });
            return response;
        }
        throw new Error('Unsupported MFA device type');
    }
    catch (error) {
        logger.error(error);
        if (error instanceof Response) {
            const responseError = yield error.json();
            if (responseError.code === 'mfa_invalid_code') {
                throw new MfaInvalidOtpError();
            }
        }
        throw error;
    }
});
const getRecoveryCodes = (_g) => __awaiter(void 0, [_g], void 0, function* ({ environmentId, }) {
    try {
        const { recoveryCodes } = yield sdkApi().getRecoveryCodes({
            environmentId,
        });
        return recoveryCodes;
    }
    catch (e) {
        const data = yield e.json();
        logger.error(data.error);
        return [];
    }
});
const createNewRecoveryCodes = (_h) => __awaiter(void 0, [_h], void 0, function* ({ environmentId, }) {
    try {
        const { recoveryCodes } = yield sdkApi().createNewRecoveryCodes({
            environmentId,
        });
        return recoveryCodes;
    }
    catch (e) {
        const data = yield e.json();
        logger.error(data.error);
        return [];
    }
});
// used when verifying a device when user is logging in with recovery code
// jwt update needed
const authMfaRecovery = (_j) => __awaiter(void 0, [_j], void 0, function* ({ environmentId, code, }) {
    try {
        const request = {
            code,
        };
        const response = yield sdkApi().authMfaRecovery({
            environmentId,
            mFAAuthRecoveryDevicePostRequest: request,
        });
        return response;
    }
    catch (e) {
        const data = yield e.json();
        logger.error(data.error);
        return undefined;
    }
});

export { addMfaDevice, authMfaDevice, authMfaRecovery, createNewRecoveryCodes, deleteMfaDevice, getRecoveryCodes, getUserMfaDevices, updateUserMfaDevice, verifyMfaDevice };
